import defaultStatus from '../config/defaultStatus';
import types from './types';

export const state = {
  globalResponseStatus: 'accepted',
};

export const mutations = {
  [types.SET_GLOBAL_RESPONSE_STATUS](state, statusKey) {
    state.globalResponseStatus = defaultStatus[statusKey];
  },
};



// WEBPACK FOOTER //
// ./src/screens/Status/store/mutations.js